import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UBXSnack, UBXSnackPosition, UBXColor } from '../models';

@Injectable({
    providedIn: 'root'
})
export class UBXSnackbarService {
    private subject: Subject<UBXSnack> = new Subject<UBXSnack>();

    getSnack(): Observable<UBXSnack> {
        return this.subject.asObservable();
    }

    success(position: UBXSnackPosition, message: string, timer?: number | boolean) {
        this.pushSnack(UBXColor.Scs, position, message, timer);
    }
    error(position: UBXSnackPosition, message: string, timer?: number | boolean) {
        this.pushSnack(UBXColor.Dgr, position, message, timer);
    }
    warning(position: UBXSnackPosition, message: string, timer?: number | boolean) {
        this.pushSnack(UBXColor.Wrn, position, message, timer);
    }
    info(position: UBXSnackPosition, message: string, timer?: number | boolean) {
        this.pushSnack(UBXColor.Inf, position, message, timer);
    }

    private pushSnack(type: UBXColor, position: UBXSnackPosition, message: string, timer: number | boolean = 5000) {
        this.subject.next({ type, position, message, timer } as UBXSnack);
    }
}
